import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=b9a13ed2&scoped=true"
import script from "./editform.vue?vue&type=script&lang=js"
export * from "./editform.vue?vue&type=script&lang=js"
import style0 from "./editform.vue?vue&type=style&index=0&id=b9a13ed2&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a13ed2",
  null
  
)

export default component.exports